import { dancingScript, montserrat } from '../fonts';

export default {
  fonts: {
    montserrat: montserrat.style.fontFamily,
    dancingScript: dancingScript.style.fontFamily,
  },
};
